import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=fda7fc48&scoped=true&"
import script from "./UpdateDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda7fc48",
  null
  
)

export default component.exports